import { ia } from 'lib/helpers/utility';

import { amountToCents } from 'components/practice/BeyondBilling/Claims/CMS1500/lib/amountToCents';

export const displayDiagnosis = (claim) => {
  const diagnosisArr = [];

  for (let i = 1; i <= 12; i++) {
    if (claim[`diag_${i}`]) diagnosisArr.push(claim[`diag_${i}`]);
  }

  return String(diagnosisArr);
};

export const sumAdjustment = (procedures, refType, refId, payerType) => {
  const formattedPayerType = payerType?.toLowerCase() ?? 'primary';

  const total = procedures?.reduce((acc, procedure) => {
    const adjustment = procedure?.[formattedPayerType];

    if (!adjustment) {
      procedure?.adjustment?.forEach((adj) => {
        acc += amountToCents(adj?.amount);
      });
    } else {
      const matchingEntry = adjustment?.find(
        (entry) => entry?.ref_type === refType && entry?.ref_id === refId
      );

      if (matchingEntry) {
        matchingEntry?.ins_adj?.forEach((adj) => {
          acc += amountToCents(adj?.amount);
        });
      } else {
        procedure?.adjustment?.forEach((adj) => {
          acc += amountToCents(adj?.amount);
        });
      }
    }
    return acc;
  }, 0);

  return total;
};

export const sumInsPaid = (procedures, refId, refType, payerType) => {
  const formattedPayerType = payerType?.toLowerCase() ?? 'primary';

  return procedures?.reduce((acc, procedure) => {
    const insType = procedure?.[formattedPayerType];
    if (ia(insType)) {
      const match = insType?.find((e) => e?.ref_type === refType && e?.ref_id === refId);
      if (match) {
        acc += Number(match?.paid) || 0;
      } else {
        const adjustmentsLength = insType?.length - 1 || 0;
        const lastAdjustment = insType[adjustmentsLength];
        acc += Number(lastAdjustment?.paid) || 0;
      }
    }

    return acc;
  }, 0);
};

export const sumProcedureInsPaid = (procedure, refId, refType, payerType) => {
  const formattedPayerType = payerType?.toLowerCase() ?? 'primary';
  let insPaid;

  const insType = procedure?.[formattedPayerType];
  if (ia(insType)) {
    const match = insType?.find((e) => e?.ref_type === refType && e?.ref_id === refId);
    if (match) {
      const paid = Number(match?.paid) || 0;
      insPaid = (insPaid || 0) + paid;
    } else {
      const adjustmentsLength = insType?.length - 1 || 0;
      const lastAdjustment = insType[adjustmentsLength];
      const paid = Number(lastAdjustment?.paid) || 0;
      insPaid = (insPaid || 0) + paid;
    }
  }

  return insPaid;
};
